import {
  buildMcaIncidentDetailsFormSpecification,
  cityOfLondonOption,
  londonBoroughOptions,
  type McaIncidentDetailsFormData as CommonMcaIncidentDetailsFormData,
} from "../common/mcaIncidentDetails.js";

export const formSpecification = buildMcaIncidentDetailsFormSpecification({
  londonBoroughOptions: [cityOfLondonOption, ...londonBoroughOptions],
});

export type McaIncidentDetailsFormData = CommonMcaIncidentDetailsFormData;
